export default "__VITE_ASSET__tj8GjCUo__"